import React from 'react';
import Box from '../../../hoc/Box/Box';
import classes from './ResidentNetworks.css';



const ResidentNetworks = (props) => {
    const { tenantDetails } = props;

    // WIN-1603: Compute stats client-side from tenant content data
    const content = tenantDetails?.content || [];
    const counts = content.reduce((acc, tenant) => {
      const status = tenant?.connectionStatus || 'NA';
      if (acc.hasOwnProperty(status)) {
        acc[status] += 1;
      } else {
        acc.NA += 1;
      }
      acc.total += 1;
      return acc;
    }, { total: 0, NA: 0, INACTIVE: 0, CONNECTED: 0, SUSPENDED: 0, OFFLINE: 0, OFFLINE_SUSPENDED: 0 });

    const { CONNECTED, total } = counts;
    // All tenants returned from CREST are provisioned — they all have service
    const totalUnits = total;
    const unitsWithService = total;
    // Networks Up = connected units / total units
    const networkup = totalUnits > 0 ? (CONNECTED / totalUnits) * 100 : 0;

    const isMduBulkNotReady = tenantDetails?.accountClassification === "MDUBULK" && !tenantDetails?.isSpectrumReady;
    const isClassificationNull = !tenantDetails?.accountClassification;

    const statsContent = (
        <div className={classes.networkUnits}>
            <div className={classes.units}>
                <h2>{unitsWithService > 0 ? `${Math.round(networkup)}%` : '0%'}</h2>
                <span id = 'PSPNetUp'>Networks Up</span>
            </div>
            <div className={classes.units}>
                <h2>{totalUnits || 'N/A'}</h2>
                <span id = 'PSPUnitUp'>Total Units</span>
            </div>
            <div className={classes.units}>
                <h2>{unitsWithService}</h2>
                <span id = 'PSPUnitService'>Units With Service</span>
            </div>
        </div>
    );

    if (isMduBulkNotReady || isClassificationNull) {
        return (
            <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: '4px', padding: '20px 28px' }}>
                <div className={classes.networkUnits} style={{ marginBottom: 0 }}>
                    <div className={classes.units}>
                        <h2>{unitsWithService > 0 ? `${Math.round(networkup)}%` : '0%'}</h2>
                        <span id = 'PSPNetUp'>Networks Up</span>
                    </div>
                    <div className={classes.units}>
                        <h2>{totalUnits || 'N/A'}</h2>
                        <span id = 'PSPUnitUp'>Total Units</span>
                    </div>
                    <div className={classes.units}>
                        <h2>{unitsWithService}</h2>
                        <span id = 'PSPUnitService'>Units With Service</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Box>
            <React.Fragment>
                {statsContent}
            </React.Fragment>
        </Box>
    );
}

export default ResidentNetworks;
